import { FC } from 'react';
import { Flex } from 'antd';
import { DataTable, ModalDialog, SLabelTitle } from '../..';
import { IDataSource, IProps } from './type';
import { getColumns } from './columns';

const RemoveParentModal: FC<IProps> = (props) => {
  const columns = getColumns(
    props.branches,
    props.cities,
    props.countries,
    props.damageTypes,
    props.organizations,
  );

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <SLabelTitle>Seçili Dosya</SLabelTitle>
        <DataTable<IDataSource>
          columns={columns}
          dataSource={props.item}
          isPaginationDisplayed={false}
          statusChoices={props.statusChoices}
        />
      </Flex>
      <Flex gap="middle" vertical>
        <SLabelTitle>Bağlı Diğer Dosyalar</SLabelTitle>
        <DataTable<IDataSource>
          columns={columns}
          dataSource={props.list}
          isPaginationDisplayed={false}
          statusChoices={props.statusChoices}
        />
      </Flex>
    </ModalDialog>
  );
};

export default RemoveParentModal;
